import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeLocale } from '../../actions/LocaleChangeAction';
import LinkItem from './LinkItem';

class HeaderLinks extends Component {
  state = {
    showLanguageSelection: false
  };

  selectLanguage = e => {
    this.setState({
      showLanguageSelection: false
    });

    this.props.changeLocale({
      locale: e.currentTarget.dataset.id,
      selectedLanguage: e.currentTarget.innerHTML
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="links">
          <a
            style={{ cursor: 'pointer' }}
            onClick={() =>
              this.setState({
                showLanguageSelection: !this.state.showLanguageSelection
              })
            }
          >
            {this.props.selectedLanguage}
            {this.state.showLanguageSelection ? (
              <i className="fa fa-angle-up" aria-hidden="true"></i>
            ) : (
              <i className="fa fa-angle-down" aria-hidden="true"></i>
            )}
          </a>
          <span className="pipe">&nbsp;</span>
          <a href="https://www.bd.com">
            <i className="fa fa-globe" aria-hidden="true"></i> BD Worldwide
          </a>
        </div>
        {this.state.showLanguageSelection ? (
          <div className="languages">
            <div className="pad">
              <div className="row">
                <div className="col-sm-12">
                  <ul>
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="English"
                      dataId="en"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="Français"
                      dataId="fr"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="Español"
                      dataId="es"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="日本語"
                      dataId="ja"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="Portuguese"
                      dataId="pt"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="Deutsch"
                      dataId="de"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="中文"
                      dataId="zh"
                    />
                    <LinkItem
                      onClick={this.selectLanguage}
                      name="한국어"
                      dataId="ko"
                    />
                  </ul>
                </div>
              </div>
              <a
                className="close"
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  this.setState({
                    showLanguageSelection: false
                  })
                }
              >
                ×
              </a>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

HeaderLinks.propTypes = {
  changeLocale: PropTypes.func.isRequired,
  locale: PropTypes.string,
  selectedLanguage: PropTypes.string
};

HeaderLinks.defaultProps = {
  locale: 'en',
  selectedLanguage: 'English'
};

const mapStateToProps = state => {
  return {
    locale: state.localeReducer.locale.locale,
    selectedLanguage: state.localeReducer.locale.selectedLanguage
  };
};

export default connect(mapStateToProps, { changeLocale })(HeaderLinks);
